
const GetBaseUrl = () => {
  const baseUrl = `https://panel.nesmaairlineseg.com/api/`;
  //  const baseUrl = `https://nesma.enjoycareeg.com/api/`;
  return baseUrl;
};
export default GetBaseUrl;

export const getDomainName=()=>{
  const baseUrl = `https://panel.nesmaairlineseg.com`;
  //  const baseUrl = `https://nesma.enjoycareeg.com`;
  return baseUrl;
}
